import React from "react";
import { useLoginStepsContext } from "../contexts";

export const useLoginSteps = () => {
  const { items, currentItemIndex, onCurrentItemChange } =
    useLoginStepsContext();

  const CurrentItem = React.useMemo(
    () => items[currentItemIndex],
    [items, currentItemIndex]
  );

  const onNextStep = React.useCallback(() => {
    onCurrentItemChange(prevStepIndex =>
      Math.min(prevStepIndex + 1, items.length - 1)
    );
  }, [onCurrentItemChange, items.length]);

  const onPrevStep = React.useCallback(() => {
    onCurrentItemChange(prevStepIndex => Math.max(prevStepIndex - 1, 0));
  }, [onCurrentItemChange]);

  return {
    CurrentItem,
    onNextStep,
    onPrevStep,
  };
};
